__turbopack_context__.v({
  "active": "FilterInhoud-module-scss-module__-D1UJW__active",
  "kenniscentrumOfReleasenotes": "FilterInhoud-module-scss-module__-D1UJW__kenniscentrumOfReleasenotes",
  "nonActive": "FilterInhoud-module-scss-module__-D1UJW__nonActive",
});
